/**
 * Encrypt and decrypt XOR util.
 *
 * @author Ihar Kazlouski
 * @param {string} inpString input string.
 * @param {string} inpString xorKey key.
 * @return {string} value.
 */
var encryptDecrypt = function encryptDecrypt(inpString, xorKey) {
  var splitedInpString = inpString.split('');
  var len = inpString.length;

  for (var i = 0; i < len; i++) {
    splitedInpString[i] = String.fromCharCode(inpString[i].charCodeAt(0) ^ xorKey.charCodeAt(0));
  }

  return splitedInpString.join('');
};

export { encryptDecrypt };